<template>
    <div>
        <Login />
    </div>
</template>
<script setup>
import { Link } from '@inertiajs/vue3';
import Login from '@/components/auth/login.vue';
</script>
